import { combineReducers } from "redux";

import { personalApiReducers as personal } from "./personal";
import { teamApiReducers as team } from "./team";

const apiFoldersReducers = combineReducers({ personal, team });

export default apiFoldersReducers;
